import { MembershipType } from '__generatedTypes__/globalTypes'
import { pluralize } from 'utils/pluralize'

type Params = {
  membershipType: MembershipType
  duration: number
}

const membershipTypeToName = new Map<MembershipType, string>([
  [MembershipType.Free, 'Free'],
  [MembershipType.Premium, 'Premium'],
  [MembershipType.PremiumMax, 'Premium Max'],
])

function formatMembershipName(membershipType: MembershipType) {
  return membershipTypeToName.get(membershipType) ?? membershipType
}

function formatDuration(duration: number) {
  return Number.isFinite(duration) ? `${duration}-${pluralize(duration, 'Day', 'Days')}` : undefined
}

export function formatMembership(params: Params) {
  return [formatDuration(params.duration), formatMembershipName(params.membershipType)].filter(Boolean).join(' ')
}
